import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import { Menu, X } from "lucide-react"

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="sticky top-0 w-full flex items-center justify-between px-6 py-4 bg-heroBg bg-opacity-95 backdrop-blur-lg z-50 shadow-md md:px-12 md:py-5">
      <div className="flex items-center space-x-3 md:space-x-4">
        <img src="/atlogo.png" alt="Astro Trader Logo" className="h-10 md:h-14" />
        <h1 className="text-xl md:text-3xl font-bold text-[#041c16] tracking-wide">AstroTrader</h1>
      </div>
      <div className="md:hidden">
        <button onClick={() => setMenuOpen(!menuOpen)} className="text-[#041c16] focus:outline-none">
          {menuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>
      <ul className={`absolute top-16 left-0 w-full bg-heroBg shadow-md flex flex-col items-center space-y-6 py-6 text-lg font-semibold text-[#041c16] md:relative md:top-0 md:flex md:flex-row md:space-y-0 md:space-x-6 md:shadow-none md:w-auto md:bg-transparent ${menuOpen ? "flex" : "hidden"}`}>
        <li><Link to='/stars' className="hover:text-gold transition" onClick={() => setMenuOpen(false)}>Stars</Link></li>
        <li><Link to='/thoughts' className="hover:text-gold transition" onClick={() => setMenuOpen(false)}>Thoughts</Link></li>
        <li><Link to='/about' className="hover:text-gold transition" onClick={() => setMenuOpen(false)}>About</Link></li>
        <li><Link to='/' className="hover:text-gold transition" onClick={() => setMenuOpen(false)}>FAQs</Link></li>
        <li><Link to='/login' className='px-4 py-2 bg-gold text-[#041c16] rounded-lg font-bold shadow-md hover:bg-opacity-90 transition' onClick={() => setMenuOpen(false)}>Join Now</Link></li>
      </ul>
    </nav>
  );
};

const Hero = () => (
  <section className="relative flex flex-col items-center justify-center h-screen px-6 text-center bg-heroBg md:px-8">
    <img src="/atlogo.png" alt="Astro Trader Logo" className="h-20 md:h-36 mb-4 md:mb-6" />
    <h1 className="text-4xl md:text-6xl font-extrabold text-astro relative after:block after:h-1 after:w-16 md:after:w-24 after:bg-gold after:mx-auto after:mt-3">AstroTrader</h1>
    <p className="mt-4 text-sm md:text-lg text-gray-700 max-w-md md:max-w-2xl">See the Stars' Guiadance. Namaste.</p>
    <Link to='/login' className='mt-6 md:mt-8 px-6 py-2 md:px-8 md:py-3 text-sm md:text-lg font-semibold text-[#041c16] bg-gold rounded-lg shadow-lg transform hover:scale-105 transition-all'>Get Started</Link>
    <div className="mt-10 flex flex-col md:flex-row md:justify-center gap-8 max-w-4xl text-center">
      <div className="border-b md:border-r md:border-b-0 border-gold pb-4 md:pb-0 md:pr-8">
        <h2 className="text-3xl md:text-5xl font-bold text-astro">500K+</h2>
        <p className="text-gray-700 text-sm md:text-base">Stars in our Skies</p>
      </div>
      <div className="border-b md:border-r md:border-b-0 border-gold pb-4 md:pb-0 md:pr-8">
        <h2 className="text-3xl md:text-5xl font-bold text-astro">4.6</h2>
        <p className="text-gray-700 text-sm md:text-base">Big-Ups from people</p>
      </div>
      <div>
        <h2 className="text-3xl md:text-5xl font-bold text-astro">$1B+</h2>
        <p className="text-gray-700 text-sm md:text-base">Zimbabwe dollars</p>
      </div>
    </div>
  </section>
);

const Features = () => {
  const features = [
    {
      title: "Unique Strategy",
      description: "Blend cosmic insight with crypto trends to spot meme coin momentum before the herd.",
    },
    {
      title: "Track Token Energy",
      description: "Visualise coin velocity, acceleration, and community gravity in real-time.",
    },
    {
      title: "Trade with Intuition",
      description: "Let your zodiac sign guide your portfolio strategy — and still outplay the market.",
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-5xl font-bold text-astro">Why Astro Trader?</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mt-14">
          {features.map((feature, i) => (
            <div
              key={i}
              className="glass p-6 shadow-2xl bg-heroBg text-astro transform transition-all duration-300 hover:scale-105 hover:shadow-3xl border border-gold"
            >
              <h3 className="text-2xl font-semibold text-astro">{feature.title}</h3>
              <p className="mt-3 text-astro">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const Footer = () => (
  <footer className="bg-dark-green text-white py-6 md:py-8 mt-auto w-full">
    <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center px-4 md:px-6">
      <p className="text-xs md:text-sm">AstroTrader Creations. All Rights Reservered.</p>
      <ul className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-6 text-xs md:text-sm mt-3 md:mt-0">
        <li><Link to='/' className="hover:text-gold transition">All Personal and Privacy data are suject to Google usage. This is Not Financial Advice, please seek Financial Assistant trade at your own Risk</Link></li>
        <li><Link to='/' className="hover:text-gold transition"></Link></li>
        <li><Link to='/' className="hover:text-gold transition"></Link>This is Entertainment</li>
      </ul>
    </div>
  </footer>
);

const LandingPage = () => (
  <div className="min-h-screen flex flex-col justify-between">
    <Navbar />
    <Hero />
    <Features />
    <Footer />
  </div>
);

export default LandingPage;
